import React from 'react';
import style from './ViewWindow.module.css';
import CustomIcon from '../CustomIcon/CustomIcon';
import {
	getSession,
} from 'Vulture/Session';

import {
	hasGlobalScope,
} from 'Vulture/Permissions';

class ViewWindow extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			showAdvancedView: false,
			testCols:         [],
			searchTerm:       '',
		};
	}

	render() {
		const {
			show,
			hideContentGroupsControls,
			windowTitle,
			hideEditButton,
		} = this.props;

		let editButton = null;
		if (!hideEditButton && hasGlobalScope()) {
			editButton = (
				<div className={style.editButtonCont}
					title="Edit"
					onClick={(e) => {
						e.preventDefault();
						this.setState({
							showAdvancedView: !this.state.showAdvancedView,
						});
					}}
				>
					<CustomIcon icon='edit' color='#00baff' />
				</div>
			);
		}

		return (
			<>
				{show ?
					<>
						<div className={style.popoverBackground} />
						<div
							className={style.viewWindow}
							style={{
								width: this.props.customWidth ? this.props.customWidth : '',
							}}
						>
							<div className={style.closeViewWindow}>
								<button onClick={(e) => {
									e.preventDefault();
									this.props.close();
								}}>
									<CustomIcon icon="times-circle" />
								</button>
							</div>
							<div className={style.viewHeaderContainer}>
								<div className={style.viewHeader} data-test-id="viewWindowToggle">
									<CustomIcon icon="eye" /> {windowTitle || (this.state.showAdvancedView ? 'View Edit Mode' : 'Filter Column View')} {editButton}
								</div>

							</div>
						{!hideContentGroupsControls && <div className={style.viewHeaderContainer}>
							<input className={style.thFilter}
								id='datafilter'
								data-test-id='viewWindowFilter'
								placeholder='Filter...'
								value={this.state.searchTerm}
								onChange={(e) => {
									let testCols = this.props.getColumns(this.state.showAdvancedView, e.target.value);
									this.setState({
										testCols,
										searchTerm: e.target.value,
									});
								}}/>
							{this.props.isSlideshow || this.props.showViewAllButtons?.parentsFirstColumnAttr === undefined ?
								<>
									<button
										className={`button ${style.toggleButton}`}
										onClick={(e) => {
											e.preventDefault();
											this.props.toggleContentGroups(true);
										}}
									>
										View All
									</button>
									<button
										className={`button ${style.toggleButton}`}
										onClick={(e) => {
											e.preventDefault();
											this.props.toggleContentGroups(false);
										}}
									>
										View None
									</button>
								</> :
								null
							}
							</div>}
							{this.state.searchTerm === '' ? this.props.getColumns(this.state.showAdvancedView) : this.props.getColumns(this.state.showAdvancedView, this.state.searchTerm)}
						</div>
					</> :
					null
				}
			</>
		);
	}
}

export default ViewWindow;